import _ from 'lodash';

_.templateSettings.interpolate = /{([\s\S]+?)}/g;

export default (route, params = {}) => {
    return _.template(route)(params);
};
